import * as aeRoleUtils from '@/components/partials/jobs/JobsInquiryForm/utils/aeRoleUtils';
import * as utils from '@/components/partials/jobs/JobsInquiryForm/utils/common';
import { getDealSizeField } from '@/components/partials/jobs/JobsInquiryForm/utils/sectionFields';
import type {
  JobsSectionField,
  JobsSectionModels,
} from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';

export default ({ inquiry }: JobsSectionModels): JobsSectionField[] => {
  return [
    {
      attrs: {
        label: aeRoleUtils.getAeQuotaFieldName(inquiry),
        value: aeRoleUtils.getAeQuotaFieldValue(inquiry),
        attributeName: 'aeQuotaPerPeriod',
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ inquiry }) => utils.isSingleFieldFilled(inquiry.aeQuotaPerPeriod),
    },
    {
      attrs: {
        label: aeRoleUtils.getAeQuotaAttainmentFieldName(inquiry),
        value: utils.getQuotaAttainment(inquiry),
        attributeName: 'quotaAttainmentPerPeriod',
        isHidden: aeRoleUtils.getIsAeQuotaAttainmentHidden(inquiry),
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ inquiry }) => utils.isSingleFieldFilled(inquiry.quotaAttainmentPerPeriod),
    },
    {
      attrs: {
        label: 'Quota attainment last year',
        value: aeRoleUtils.getAeLastYearQuotaAttainment(inquiry),
        attributeName: 'quotaAttainmentPerLastYear',
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ inquiry }) => utils.isSingleFieldFilled(inquiry.quotaAttainmentPerLastYear),
    },

    getDealSizeField({ inquiry }),

    {
      attrs: {
        label: 'Quota system',
        value: aeRoleUtils.getAeQuotaTypeFieldValue(inquiry),
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ inquiry }) =>
        utils.isSingleFieldFilled(inquiry.aeQuotaTypeMain) || utils.isSingleFieldFilled(inquiry.aeQuotaTypeOther),
    },
  ];
};
